import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ConfigProvider } from "antd";

import { Loader } from "./components";

import AllRoutes from "./config/routes/all-routes";

const App = () => {
  const isLoading = useSelector((state) => state.auth.isLoading);

  const [fontSize, setFontSize] = useState(16);

  useEffect(() => {
    const updateFontSize = () => {
      console.log("Window width:", window.innerWidth);
      if (window.innerWidth >= 2133) {
        setFontSize(17.8);
      } else if (window.innerWidth < 2133 && window.innerWidth >= 1920) {
        setFontSize(16);
      } else if (window.innerWidth < 1920 && window.innerWidth >= 1745) {
        setFontSize(14.55);
      } else if (window.innerWidth < 1745 && window.innerWidth >= 1536) {
        setFontSize(12.78);
      } else if (window.innerWidth < 1536 && window.innerWidth >= 1280) {
        setFontSize(10.68);
      } else {
        setFontSize(16);
      }
    };
    updateFontSize();
    window.addEventListener("resize", updateFontSize);

    return () => window.removeEventListener("resize", updateFontSize);
  }, []);

  return (
    <ConfigProvider
      theme={{
        token: {
          fontSize: fontSize * 0.9,
        },
      }}
    >
      <div style={{ fontSize: fontSize * 0.9 }}>
        <AllRoutes />

        {isLoading ? (
          <div
            style={{
              display: "flex",
              position: "absolute",
              zIndex: 100,
              top: 0,
              bottom: 0,
              right: 0,
              left: 0,
              zIndex: 100,
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            }}
          >
            <Loader.Circular />
          </div>
        ) : null}
      </div>
    </ConfigProvider>
  );
};

export default App;
